const Title = () => <h1>React World Weather</h1>;

export default Title;